'use strict';
var React = require('react');
var ReactDOM = require('react-dom');
var assetsHelper = require('../../helper/assetsHelper');
var styleHelper = require('../../helper/styleHelper');
var storeHelper = require('../../helper/storeHelper');
var appTypes = require('../../types/appTypes');
var Resizer = require('../Resizer');

var graphicsHelper = require('../../helper/graphicsHelper');

var StylePicker = React.createClass({

    propTypes: {
        checkedTool: React.PropTypes.string.isRequired,
        colorChecked: React.PropTypes.func.isRequired,
        backColorChecked: React.PropTypes.func.isRequired,
        backAlphaCheck: React.PropTypes.func.isRequired,
        lineWidthChecked: React.PropTypes.func.isRequired,
        fontSizeChecked: React.PropTypes.func.isRequired,
        isBackColor: React.PropTypes.bool.isRequired,
        location: React.PropTypes.object.isRequired,
    },

    tool: ['RectTool', 'FilledRectTool',  'EllipseTool', 'FilledEllipseTool','ArrowTool', 'PencilTool', 'TextTool'],

    frontColorArray: ['#000000', '#808080', '#800000', '#f7883a',
                    '#308430', '#385ad3', '#800080', '#009999',
                    '#ffffff', '#c0c0c0', '#fb3838', '#ffff00',
                    '#99cc00', '#3894e4', '#f31bf3', '#16dcdc'],
    backColorArray: ['#000000', '#fb3838', '#ffff00', '#f31bf3',
                    '#ffffff', '#3894e4', '#99cc00', '#16dcdc',],
    lineWidthArray: [2,4,6],
    fontSizeArray: [12,14,16,18,20,22,24,26,28,32,36,48,72],
    boxStyle: null,
    styleObj: null,
    render: function () {
        this.styleObj = JSON.parse(storeHelper.get(this.props.checkedTool));
        var i = this.tool.indexOf(this.props.checkedTool);
        this.boxStyle = {
            left: this.props.location.left+i*44 + 8,
        };

        switch(this.props.checkedTool) {
            case 'RectTool':
            case 'EllipseTool':
            case 'ArrowTool':
            case 'PencilTool':
                return this.getStrokeRender();
            case 'TextTool':
                return this.getTextRender();
            case 'FilledRectTool':
            case 'FilledEllipseTool':
                return this.getFillRender();

        }
    },

    componentDidMount: function() {
        var range = $("input[type='range']");
        range.change(this.updateSlider);
    },

    getTextRender: function() {
        var reactContext = this;
        var colorArray = this.frontColorArray;
        if(this.props.isBackColor) {
            colorArray = this.backColorArray;
        }
        return (
        <div className='style-picker-box' style={this.boxStyle}>
            <div className='font-box'>
                <span className='font-icon-style'>A</span>
                <div className='font-check-box'>
                    <select className='font-check-style' value={reactContext.styleObj.fontSize} onChange={this.fontSizeChecked}>
                        {
                            this.fontSizeArray.map(function(fontSize, index) {

                                return (<option value={fontSize}>{fontSize}</option>);
                            })
                        }
                    </select>
                </div>
            </div>

            <div className='color-box'>
                <div className='checked-color-box'>
                    <div className='front-checked-color' style={{
                                backgroundColor: this.styleObj.color,
                                border:this.props.isBackColor?'':'1px solid black',
                                zIndex:this.props.isBackColor?10003:10004,
                            }} onClick={this.props.switchToFront}>
                    </div>
                    <div className='back-checked-color' style={{
                                backgroundColor: this.styleObj.backColor,
                                left: this.props.isBackColor?6:8,
                                border:this.props.isBackColor?'1px solid black':'',
                                zIndex:this.props.isBackColor?10004:10003,
                            }} onClick={this.props.switchToBack}>
                    </div>
                </div>
                <div className='color-check-box' style={{width:this.props.isBackColor?64:128}}>
                    {
                        colorArray.map(function(color, index) {
                            return (
                                <div className='color-item' style={{
                                        backgroundColor:color,
                                    }} onClick={reactContext.textColorChecked}>

                                </div>);
                        })
                    }
                </div>
                {this.props.isBackColor &&
                <div className='range-box'>
                    <input type='range' min='1' max='100' value={this.styleObj.backColorAlpha*100}
                           step='5' onChange={this.updateSlider}/>
                </div>}
            </div>
        </div>
        );
    },

    getFillRender: function() {
        var reactContext = this;
        this.boxStyle['width'] = 170;
        return (
            <div className='style-picker-box' style={this.boxStyle}>
                <div className='color-box'>
                    <div className='checked-color' style={{
                                    backgroundColor: this.styleObj.backColor,
                                }}>
                    </div>
                    <div className='color-check-box' style={{width:64}}>
                        {
                            this.backColorArray.map(function(color, index) {
                                return (
                                <div className='color-item' style={{
                                                backgroundColor:color,
                                            }} onClick={reactContext.backColorChecked}>
                                </div>);
                                })
                            }
                    </div>
                    <div className='range-box'>
                        <input type='range' min='1' max='100' value={this.styleObj.backColorAlpha*100}
                               step='5' onChange={this.updateSlider}/>
                    </div>
                </div>
            </div>)
    },

    getStrokeRender: function() {
        var reactContext = this;
        return (
            <div className='style-picker-box' style={this.boxStyle}>
                <div className='line-width-check'>
                {
                this.lineWidthArray.map(function(lineWidth) {
                    return (<div className='line-check-box' name={lineWidth} onClick={this.lineWidthChecked}
                                 style={{
                                     width: 23-(lineWidth===this.styleObj.strokeWidth?2:0),
                                     height: 23-(lineWidth===this.styleObj.strokeWidth?2:0),
                                     border:lineWidth===this.styleObj.strokeWidth?'1px solid gray':'',
                                 }} >
                        <div style={{
                                width:lineWidth,
                                height:lineWidth,
                                marginTop:(23-lineWidth)/2-(lineWidth===this.styleObj.strokeWidth?1:0),
                                marginLeft:(23-lineWidth)/2-(lineWidth===this.styleObj.strokeWidth?1:0),
                            }} className='line-width' name={lineWidth} onClick={this.lineWidthChecked}></div>
                    </div>
                        );
                    }, this)
                }
                </div>

                <div className='color-box'>
                    <div className='checked-color' style={{
                            backgroundColor: this.styleObj.color,
                        }}>
                    </div>
                    <div className='color-check-box'>
                        {
                            this.frontColorArray.map(function(color, index) {
                                return (
                                    <div className='color-item' style={{
                                    backgroundColor:color,
                                }} onClick={reactContext.colorChecked}>

                                    </div>);
                            })
                        }
                    </div>
                </div>

            </div>)
    },

    updateSlider: function(e) {
        var value = e.target.value;
        this.props.backAlphaCheck(value);
    },

    textColorChecked: function(e) {
        var node = e.target;
        var value = $(node).css("background-color");
        if(this.props.isBackColor) {
            this.props.backColorChecked(value);
        } else {
            this.props.colorChecked(value);
        }
    },

    colorChecked: function(e) {
        var node = e.target;
        var value = $(node).css("background-color");
        this.props.colorChecked(value);
    },

    backColorChecked: function(e) {
        var node = e.target;
        var value = $(node).css("background-color");
        this.props.backColorChecked(value);
    },

    lineWidthChecked: function(e) {
        var lineWidth = parseInt($(e.target).attr('name'), 10);
        this.props.lineWidthChecked(lineWidth);
    },

    fontSizeChecked: function(e) {
        var select = e.target;
        $(select).blur();
        var index = select.selectedIndex;
        var value = parseInt(select.options[index].value);
        this.props.fontSizeChecked(value);
    },

});

module.exports = StylePicker;



// WEBPACK FOOTER //
// ./src/views/Review/StylePicker.jsx